import React from 'react';
import LetsStart from "../LetsStart/LetsStart";


const Home = () => {
  return (
    <LetsStart />
  );
};

export default Home;
